module.exports = __webpack_public_path__ + "static/img-wisdom.cc39b390.jpg";